module.exports = __webpack_public_path__ + "media/images/partners/stem_square-100c659fc8f5c118cb9ec241e6b64ba2.svg";